import { render } from "./ButtonLike.vue?vue&type=template&id=8f6f61a8&scoped=true"
import script from "./ButtonLike.vue?vue&type=script&lang=js"
export * from "./ButtonLike.vue?vue&type=script&lang=js"

import "./ButtonLike.vue?vue&type=style&index=0&id=8f6f61a8&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f6f61a8"]])

export default __exports__